// extracted by mini-css-extract-plugin
export default {"testimonialSection":"_2f4YloTl","testimonialHeading":"_1Gb0kTYf","testimonialCard":"_3YXmd0_8","stars":"_2t9a7rbR","testimonialAuthor":"ma8stIda","testimonialDate":"_1FMgDP11"};